import { BellRing, History } from "lucide-react";
import { useRouter } from "@tribunalea/ui";

const items = [
  {
    to: "/alertas",
    label: "Alertas configuradas",
    icon: BellRing,
  },
  {
    to: "/alertas/historial",
    label: "Historial de envíos",
    icon: History,
  },
];

export function AlertsSectionNav() {
  const { path, navigate } = useRouter();

  return (
    <nav className="alerts-section-nav" aria-label="Secciones de Alertas">
      {items.map((item) => {
        const Icon = item.icon;
        const active = path === item.to;
        return (
          <button
            key={item.to}
            type="button"
            className={active ? "active" : ""}
            aria-current={active ? "page" : undefined}
            onClick={() => navigate(item.to)}
          >
            <Icon size={16} />
            {item.label}
          </button>
        );
      })}
    </nav>
  );
}
